import type { GridFilterModel } from "@mui/x-data-grid-pro";

import type { GridRow, IGridFilterConfig } from "@/apps/engagement-letter-database/data/types";

import { matchesFilterItem } from "./matchesFilterItem";

function applyGridFilterModel<T extends GridRow>(rows: T[], model: GridFilterModel, config: IGridFilterConfig): T[] {
  const items = (model.items ?? []).filter((i) => i.field && i.operator);
  const quick = (model.quickFilterValues ?? []).filter(Boolean);
  if (items.length === 0 && quick.length === 0) return rows;

  const useOr = model.logicOperator === 'or';

  return rows.filter((row) => {
    if (items.length) {
      const results = items.map((item) => matchesFilterItem(row, item, config));
      const pass = useOr ? results.some(Boolean) : results.every(Boolean);
      if (!pass) return false;
    }
    if (quick.length) {
      const hay = config.quickFilterFields
        .map((f) => row[f])
        .join(' ')
        .toLowerCase();
      return quick.every((term) => hay.includes(String(term).toLowerCase()));
    }
    return true;
  });
}

export { applyGridFilterModel };